var map = {
	"./Nurse/LearningResources.vue": [
		"6115",
		"chunk-6e683559"
	],
	"./actor/LearningResources.vue": [
		"431a",
		"chunk-610247cb"
	],
	"./components/LearningResources.vue": [
		"fd97"
	],
	"./construction/LearningResources.vue": [
		"362c",
		"chunk-92bdc45e"
	],
	"./creativeindustries/LearningResources.vue": [
		"722b",
		"chunk-3f10c230"
	],
	"./developer/LearningResources.vue": [
		"e817",
		"chunk-9c142de0"
	],
	"./doctor/LearningResources.vue": [
		"c11c",
		"chunk-b5dc89e6"
	],
	"./engineering/LearningResources.vue": [
		"3034",
		"chunk-772bbb1c"
	],
	"./entrepreneur/LearningResources.vue": [
		"7481",
		"chunk-3fcb9e7d"
	],
	"./envscience/LearningResources.vue": [
		"1ff6",
		"chunk-749fd6f3"
	],
	"./fitness/LearningResources.vue": [
		"c3af",
		"chunk-b7682160"
	],
	"./forensic_science/LearningResources.vue": [
		"54bd",
		"chunk-5117e90a"
	],
	"./gamesdeveloper/LearningResources.vue": [
		"18c8",
		"chunk-6a6ecd3a"
	],
	"./hairdressing/LearningResources.vue": [
		"6c69",
		"chunk-689169c1"
	],
	"./law/LearningResources.vue": [
		"ee59",
		"chunk-7346ff38"
	],
	"./physiotherapy/LearningResources.vue": [
		"5e75",
		"chunk-4c3ad63d"
	],
	"./policing/LearningResources.vue": [
		"a06d",
		"chunk-1ea25bfd"
	],
	"./psychology/LearningResources.vue": [
		"3716",
		"chunk-50bb6bfe"
	],
	"./teacher/LearningResources.vue": [
		"6ee5",
		"chunk-1f0c71ce"
	],
	"./vet/LearningResources.vue": [
		"aa3c",
		"chunk-3b93d9b9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4748";
module.exports = webpackAsyncContext;